import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";

import { Grid } from '@material-ui/core';

import { GET_ALL_DEFINITIONS } from "../../queries/settings";

// components
import PageError from '../../components/PageError';
import PageLoading from '../../components/PageLoading';
import PageTitle from "../../components/PageTitle/PageTitle";

const placementsByPublisher = ({ data: { getAllDefinitions, loading, error }}) => {

  const options = {
    selectableRows: 'none',
    responsive: "scrollMaxHeight"
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Placements by Publisher"/>
        </Grid>
      </Grid>
      
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={getAllDefinitions}
                columns={[
                  {
                    name    : 'url',
                    options : {
                      empty  : true,
                      filter : true,
                      sort   : true,
                      customBodyRender: (value) => {
                        return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
                      }                
                    }
                  },{
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },{
                    name    : 'layoutType',
                    options : {
                      customBodyRender: (value) => {
                        return <div>{value.name}</div>
                      }
                    }
                  },
                  {
                    name    : 'tags',
                    options : {
                      customBodyRender: (value) => {
                        return value.map(tag => <p><b>{tag.tag}</b> 
                        {tag.isMobile ? " Mobile" : " Desktop"}
                        {!tag.showCloseButton ? " without Close Button" : ""}
                        {tag.tag === "HEADER" ? tag.isHeaderHide ? " with Header Hide" : " without Header Hide" : ""}
                        {tag.tag === "IMG" ? tag.isFullImage ? " with Full Image" : " without Full Image" : ""}
                        {tag.divElementName !== "NONE" || !tag.divElementName ? ` using query selector "${tag.divElementName}"` : ""}                        
                        </p>)
                      }
                    }
                  }
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const PlacementsByPublisher = graphql(GET_ALL_DEFINITIONS)(placementsByPublisher);